/**
 * useFriendship Hook (Web)
 * Thin wrapper around shared useFriendship
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseFriendshipResult,
  useFriendship as useFriendshipShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseFriendshipResult };

export function useFriendship(targetUserId: string): UseFriendshipResult {
  const { isAuthenticated, authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useFriendshipShared({ httpClient, targetUserId, isAuthenticated });
}
